import { render } from "./ImportServiceIssues.vue?vue&type=template&id=4126f5a8&scoped=true"
import script from "./ImportServiceIssues.vue?vue&type=script&lang=js"
export * from "./ImportServiceIssues.vue?vue&type=script&lang=js"

import "./ImportServiceIssues.vue?vue&type=style&index=0&id=4126f5a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4126f5a8"]])

export default __exports__